import { LoadingService } from "./loading-service";

export abstract class InitialLoadAction<T> {
    constructor(
        private name: string,
        private loadingService: LoadingService) { }

    private onStart() {
        this.loadingService.loadInProgress();
        console.log(`Load for ${this.name} started ...`)
    }

    private onStop() {
        this.loadingService.loadEnded();
        console.log(`Load for ${this.name} ended ...`);
    }

    abstract onLoad(): Promise<T>;

    async load(): Promise<T> {
        this.onStart();

        try {
            try {
                return await this.onLoad();
            } catch (err) {
                console.error(`Load for ${this.name} failed`, err);
                return await Promise.resolve(undefined as T);
            }
        } finally {
            this.onStop();
        }
    }
}